import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../../../../Routes/PrivateRoutes";
import TipoNegociacaoProvider from "./TipoNegociacaoContext";
import PesquisarTipoNegociacao from "./Events/PesquisarTipoNegociacao";
import FormularioTipoNegociacao from "./Events/FormularioTipoNegociacao";

const Index = () => {
  let match = useRouteMatch();
  return (
    <TipoNegociacaoProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">
        <Switch>
          <PrivateRoute
            exact
            path={`${match.url}`}
            component={PesquisarTipoNegociacao}
          />
          <PrivateRoute
            path={`${match.url}/:id`}
            component={FormularioTipoNegociacao}
          />
        </Switch>
      </div>
    </TipoNegociacaoProvider>
  );
};

export default Index;
